<template>
  <el-dialog
      title="Просмотр документа"
      :visible="visible"
      :before-close="close"
      @opened="onOpen"
      width="80%"
      class="viewer"
      :close-on-press-escape="false"
  >

    <template v-if="file.link && visible">
      <img v-if="isImage"
           :src="getUrl"
           :alt="getUrl"
           class="viewer__img"
      />

      <iframe
          v-else-if="isPDF"
          :src="`${this.getUrl}`"
          width="100%"
          style="height: 70vh;" frameborder="0">
      </iframe>

      <iframe
          v-else
          :src="`https://view.officeapps.live.com/op/embed.aspx?src=${this.getUrl}`"
          width="100%"
          style="height: 70vh;" frameborder="0">
      </iframe>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">Закрыть</el-button>
      </span>

    </template>
  </el-dialog>
</template>

<script>

export default {
  name: "ViewImages",
  data() {
    return {
      error: null,
    };
  },
  props: {
    file: {
      required: true,
    },
    visible: {
      required: true,
    }
  },
  computed: {
    isImage() {
      return this.file.ext === "jpeg" || this.file.ext === "jpg" || this.file.ext === "png"
    },
    isPDF() {
      return this.file.ext === "pdf" || this.file.ext === "txt"
    },
    getUrl() {
      return this.$root.getUrlPhoto(this.file.link.get)
    },
  },
  components: {},
  methods: {
    onOpen() {

    },
    close() {
      this.$emit('close')
    },

  }
};
</script>

<style scoped lang="scss">

.viewer {
  &__img {
    display: block;
    margin: 0 auto;
    max-width: 100%;
  }
}

</style>

